import React, { useEffect, useState } from "react";
import { Button, InputGroup } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import {
  expenseTypes,
  getCurrencyFormat,
  getExpenseSubTypes,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";

export default function ExpenseEditor(props) {
  const [expense] = useState(props.expense || {});

  const {
    total,
    type,
    subType,
    description,
    paymentType,
    setTotal,
    setType,
    setSubType,
    setDescription,
    setPaymentType,
    setSubTypes,
    subTypes,
    installment,
    installments,
    setInstallment,
    setInstallments,
  } = props;

  const editExpenseHandler = (expense) => {
    setTotal(expense.total);
    setType(expense.type);
    setSubType(expense.subType);
    setDescription(expense.description);
    setPaymentType(expense.paymentType);
    setInstallment(expense.installment);
    setInstallments(expense.installments);
  };

  useEffect(() => {
    editExpenseHandler(expense);
  }, [expense]);

  return (
    <div>
      <Form>
        <Card className="mb-3">
          <Card.Body>
            <Form.Group>
              <Form.Check
                style={{ display: "inline-block" }}
                className="mb-3"
                type="checkbox"
                label="Taksitli Ödeme?"
                value={installment}
                checked={installment}
                onChange={(e) => {
                  if (e.target.checked) {
                    setInstallment(true);
                  } else {
                    setInstallment(false);
                  }
                }}
              />
              &nbsp;
              <span className="text-secondary">
                {installment
                  ? "Taksitli ödeme seçtiniz!"
                  : "Peşin ödeme seçtiniz!"}
              </span>
            </Form.Group>
            <Form.Group className="mb-3">
              <Row>
                <Col md={9}>
                  <Form.Select
                    value={type}
                    onChange={(e) => {
                      setType(e.target.value);
                      setSubTypes(getExpenseSubTypes(e.target.value));
                    }}
                  >
                    <option value={""}>Bir gider türü seçiniz!</option>
                    {expenseTypes.map((c) => (
                      <option value={c.type} key={c.type}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
            </Form.Group>
            {subTypes && subTypes.length > 0 && (
              <Form.Group className="mb-3">
                <Row>
                  <Col md={9}>
                    <Form.Select
                      value={subType}
                      onChange={(e) => {
                        setSubType(e.target.value);
                      }}
                    >
                      <option value={""}>Bir gider alt türü seçiniz!</option>
                      {subTypes.map((c) => (
                        <option value={c.type} key={c.type}>
                          {c.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
            )}
            <Form.Group className="mb-3">
              <Row>
                <Col md={9}>
                  <Form.Control
                    value={description}
                    placeholder="Açıklama Gir"
                    type="text"
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Row>
                <Col md={9}>
                  <div className="mb-3" style={{ display: "flex" }}>
                    {installment && (
                      <span style={{ alignSelf: "center" }}>T.Tutar&nbsp;</span>
                    )}
                    <Form.Control
                      value={total}
                      placeholder={`${
                        installment ? "Toplam ödenecek tutar" : "Tutar Gir"
                      }`}
                      type="number"
                      onChange={(e) =>
                        setTotal(e.target.value ? Number(e.target.value) : null)
                      }
                      required
                    />
                  </div>
                </Col>
              </Row>
            </Form.Group>
            {installment &&
              installments.map((inst, index) => (
                <Form.Group className="mb-3" key={index}>
                  <Row>
                    <Col md={9}>
                      {index + 1 === installments.length ? (
                        <Col>
                          <div className="mb-3" style={{ display: "flex" }}>
                            <span style={{ alignSelf: "center" }}>
                              {index + 1 + ".Taksit"}&nbsp;
                            </span>

                            <InputGroup>
                              <Form.Control
                                value={installments[index].amount}
                                placeholder={`${index + 1 + ". taksit"}`}
                                type="number"
                                onChange={(e) => {
                                  const editedInstallments = [...installments];
                                  editedInstallments[index].amount = e.target
                                    .value
                                    ? Number(e.target.value)
                                    : null;
                                  setInstallments(editedInstallments);
                                }}
                              />
                              <Button
                                variant="light"
                                className="text-primary border-primary"
                                onClick={() => {
                                  setInstallments([
                                    ...installments,
                                    { amount: null },
                                  ]);
                                }}
                              >
                                <i className="fas fa-plus"></i>
                                &nbsp;
                                {"Ekle"}
                              </Button>
                              <Button
                                variant="light"
                                className="text-danger border-danger"
                                disabled={installments.length === 1}
                                onClick={() => {
                                  setInstallments(
                                    [...installments].slice(0, -1)
                                  );
                                }}
                              >
                                <i className="fas fa-minus"></i>
                                &nbsp;
                                {"Sil"}
                              </Button>
                            </InputGroup>
                          </div>
                        </Col>
                      ) : (
                        <div style={{ display: "flex" }}>
                          <span style={{ alignSelf: "center" }}>
                            {index + 1 + ".Taksit"}&nbsp;
                          </span>
                          <Form.Control
                            value={installments[index].amount}
                            placeholder={`${index + 1 + ". taksit"}`}
                            type="number"
                            onChange={(e) => {
                              const editedInstallments = [...installments];
                              editedInstallments[index].amount = e.target.value
                                ? Number(e.target.value)
                                : null;
                              setInstallments(editedInstallments);
                            }}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                </Form.Group>
              ))}
            <Form.Group>
              <Form.Check
                style={{ display: "inline-block" }}
                type="checkbox"
                label="Nakit Odeme?"
                value={paymentType === "CACHE"}
                checked={paymentType === "CACHE"}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPaymentType("CACHE");
                  } else {
                    setPaymentType("POS");
                  }
                }}
              />
              &nbsp;
              <span className="text-secondary">
                {paymentType === "CACHE"
                  ? "Nakit odeme sectiniz!"
                  : "Pos ile odeme sectiniz!"}
              </span>
            </Form.Group>

            <Form.Group>
              {installment && (
                <Row>
                  <Col md={9}>
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <span className="text-danger">Toplam: &nbsp;</span>
                          </td>
                          <td className="text-end">
                            {turkishCurrencyFormatterNoPrecision(
                              total ? getCurrencyFormat(total.toFixed(2)) : 0
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="text-danger">Ödenen:</span>{" "}
                          </td>
                          <td className="text-end">
                            {turkishCurrencyFormatterNoPrecision(
                              getCurrencyFormat(
                                installments
                                  .reduce(
                                    (a, c) => a + (c.amount ? c.amount : 0),
                                    0
                                  )
                                  .toFixed(2)
                              )
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="text-danger">Kalan:</span>{" "}
                          </td>
                          <td className="text-end">
                            {turkishCurrencyFormatterNoPrecision(
                              getCurrencyFormat(
                                (
                                  (total ? total : 0) -
                                  installments.reduce(
                                    (a, c) => a + (c.amount ? c.amount : 0),
                                    0
                                  )
                                ).toFixed(2)
                              )
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>
              )}
            </Form.Group>
          </Card.Body>
        </Card>
      </Form>
    </div>
  );
}
